import { identityPendingSource } from '@/modules/users/presentation/pending-source';
import { salesAlertsPendingSource } from '@/modules/sales/presentation/alerts-pending-source';
import { totvsPendingSource } from '@/modules/totvs/presentation/pending-source';
import type { Role } from '@/shared/guards/roles';
import type { PendingSource } from '../domain/entities/pending-alert.entity';

/**
 * Registry de fontes da Central de Pendências — mesmo desenho do `appModules`
 * em `src/app/app.module.ts`. Adicionar uma fonte nova = implementar
 * `PendingSource` no módulo dono do dado (ver `salesAlertsPendingSource`,
 * `totvsPendingSource`, `identityPendingSource`) e acrescentar uma linha aqui. Nada mais precisa mudar:
 * gate por papel, merge e filtro por módulo na tela derivam desta lista.
 */
export const PENDING_SOURCES: PendingSource[] = [
  salesAlertsPendingSource,
  totvsPendingSource,
  identityPendingSource,
];

/**
 * União dos papéis de todas as fontes registradas — libera o menu/rota da
 * Central de Pendências a quem tem **qualquer uma** delas, mesmo que só veja
 * uma das fontes depois de entrar (cada fonte segue gateada por si mesma no
 * fetch — ver `use-pending-alerts.ts`).
 */
export const PENDING_ALERTS_ROLES: Role[] = Array.from(
  new Set(PENDING_SOURCES.flatMap((source) => source.requiredRoles)),
);
